import { render, staticRenderFns } from "./DamageProducts.vue?vue&type=template&id=54e00598&"
import script from "./DamageProducts.vue?vue&type=script&lang=js&"
export * from "./DamageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports